// extracted by mini-css-extract-plugin
export default {"container":"menu_container__3ltF8","item":"menu_item__2dGcL","active":"menu_active__2k1hT"};